import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  Z_INDEXS,
  NATIVE_BASE_COLORS,
  IMG,
} from '../../themes'
import { colorThemeSelector } from '../../helpers'
const padding = 16
const Style = styled.div`
  margin: 0;
  padding: 0;
  height: 100vh;
  flex: 1;
  overflow: hidden;
  box-sizing: border-box;

  @media screen and (min-height: 1080px) {
    height: 100%;

    .booking-container-wrapper {
      height: 100%;
    }
  }
  .booking-container-wrapper {
    padding-top: 60px;
  }
    
  .content-container > .content > .content-body .div-search-select.error,
  .content-container > .content > .content-body .date-input.error,
  .content-container > .content > .content-body .notification-list.error {
    border-color: ${COLOR.RED_2} !important;
  }
  .min-height-700 {
    min-height: 700px;
  }
  .booking-container {
    flex: 1;
    overflow: hidden;
    position: relative;
    padding: 20px 0px 0px 32px;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    min-height: 100%;
    max-height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
  }
  .booking-header {
    flex: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    width: 100%;
    margin: 74px 0 15px 0;
    min-height: 38px;
  }
  .booking-header > button {
    flex: 0;
    min-width: 34px;
    max-width: 34px;
    height: 34px;
    padding: 0;
    margin: 0 10px 0 0;
  }
  .booking-header > label {
    min-width: 38px;
    font-size: 24px;
    font-weight: bold;
  }
  .booking-content {
    flex: 1 1 0px;
    overflow: scroll;
  }
  .content-container {
    display: flex;
    flex-flow: column nowrap;
    overflow: visible;
    width: 100%;
    box-sizing: border-box;
    padding: 15px 32px 30px 0px;
    margin: 0;
    flex: 1;
  }
  .notification-list {
    min-width: 200px;
  }
  .notification-list > .dropdown-container > * {
    text-align: left;
    padding-left: 10px;
  }
  .content-container > .content {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
    margin: 0 0 32px 0;
  }
  .content-container > .content > .content-header {
    min-height: 24px;
    outline: none;
    width: 100%;
    margin: 0 0 10px 0;
    font-family: NunitoSansSemiBold;
    font-size: 20px;
    color: ${COLOR.BLACK_6};
  }
  .required-mark {
    color: ${COLOR.RED_2};
    margin-left: 4px;
  }
  .content-devices {
    line-height: 36px;
    min-height: 36px;
    min-width: 210px;
    max-width: 210px;
    margin: 0 0 25px 0;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.XXS};
    cursor: default;
    border-width: medium;
    .text {
      width: max-content;
    }
  }

  .more-icon {
    left: 28px;
    position: relative;
  }
  .content-image{
    display: flex;
    margin-right: 30px;
  }
  .btn-end-meeting {
    margin-left: 40px;
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-color: ${COLOR.PEARL};
    width: 160px;
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    cursor: pointer;
    font-family: NunitoBold;
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
    font-size: ${FONT_SIZE.XXS};

  }

  .btn-end-meeting-disabled {
    margin-left: 40px;
    background: ${COLOR.PEARL};
    border-color: ${COLOR.PEARL};
    width: 160px;
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    cursor: not-allowed;
    color: ${COLOR.GRAY_3};
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.XXS};
  }

  .btn-save-disabled {
    margin-left: 12px;
    background: ${COLOR.PEARL};
    border-color: ${COLOR.PEARL};
    min-height: 40px;
    padding: 10px 24px;
    border-radius: 8px;
    line-height: 20px;
    cursor: not-allowed;
    color: ${COLOR.BLACK_6};
    font-family: NunitoSansMedium, 'Nunito Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .content-container > .content > .content-body {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    line-height: 36px;
    min-height: 36px;
    outline: none;
  }
  .limit-text {
    margin-left: 190px;
    margin-top: -30px;
  }
  .content-container > .content > .content-body select.field-input,
  .content-container > .content > .content-body .div-search-select {
    border-radius: 8px !important;
    border: 1px solid ${COLOR.GRAY_5} !important;
    background-color: transparent !important;
    box-sizing: border-box;
    width: 100%;
    padding: 12px 16px !important;
    min-height: 48px !important;
    display: flex;
    align-items: center;
  }
  
  .content-container > .content > .content-body select.field-input {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.825 7.15845L10 10.9751L6.175 7.15845L5 8.33345L10 13.3334L15 8.33345L13.825 7.15845Z' fill='%230A0A0A'/%3E%3C/svg%3E") !important;
    background-repeat: no-repeat !important;
    background-position: right 16px center !important;
    padding-right: 40px !important;
  }
  
  .content-container > .content > .content-body select.field-input:disabled {
    background-image: none !important;
  }
  
  .content-container > .content > .content-body input.field-input,
  .content-container > .content > .content-body input.input-search-dropdown {
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    line-height: 22px !important;
    height: 22px !important;
    flex: 1;
  }
  
  .content-container > .content > .content-body .div-search-select input.input-search-dropdown,
  .content-container > .content > .content-body .div-search-select input.input-field,
  .content-container > .content > .content-body .field-input {
    font-family: NunitoSansRegular !important;
    font-size: 18px !important;
    font-weight: 400 !important;
    color: ${COLOR.BLACK_6} !important;
    background-color: transparent !important;
  }
  
  .content-container > .content > .content-body .div-search-select input::placeholder,
  .content-container > .content > .content-body input.field-input::placeholder {
    color: ${COLOR.GRAY_27} !important;
    font-family: NunitoSansRegular !important;
    font-size: 18px !important;
    font-weight: 400 !important;
    opacity: 1;
  }
  
  .content-container > .content > .content-body .div-search-select.disabled,
  .content-container > .content > .content-body input:disabled,
  .content-container > .content > .content-body select:disabled {
    background-color: ${COLOR.GRAY_13} !important;
    color: ${COLOR.GRAY_27} !important;
  }

  .notification-list {
    flex-grow: 1 !important;
    flex-basis: 100% !important;
    max-width: 100% !important;
    border-radius: 8px !important;
    border: 1.5px solid ${COLOR.GRAY_5} !important;
    background-color: transparent !important;
    box-sizing: border-box !important;
    width: 100% !important;
    padding: 12px 16px !important;
    height: 48px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
  }
  
  .notification-list + .label-text {
    display: none !important;
  }
  
  .notification-list > label {
    flex: 1 !important;
    text-align: left !important;
    font-family: NunitoSansRegular, 'Nunito Sans', sans-serif !important;
    font-size: 18px !important;
    line-height: 24px !important;
    font-weight: 400 !important;
    color: ${COLOR.BLACK_6} !important;
    margin: 0 !important;
    padding: 0 !important;
    cursor: pointer !important;
  }

  .notification-list > .button-container {
    width: 24px !important;
    height: 24px !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  
  .notification-list > .button-container > img {
    width: 24px !important;
    height: 24px !important;
    margin: 0 !important;
    display: block !important;
  }
  
  .content-container > .content > .content-body .div-search-select.disabled *,
  .content-container > .content > .content-body .div-search-select.disabled input:disabled {
    background-color: transparent !important;
    color: ${COLOR.GRAY_27} !important;
  }
  .content-container > .content > .content-body .dropdown-container {
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    box-sizing: border-box;
    width: 100%;
  }
  .content-container > .content > .content-body .dropdown-container > div {
    border: none;
    border-radius: 4px;
  }
  .content-container > .content > .content-body .date-input {
    flex: 1;
    line-height: 48px;
    min-height: 48px;
    outline: none;
    min-width: 160px;
    max-width: 160px;
    cursor: pointer;
    border-radius: 8px !important;
    border: 1px solid ${COLOR.GRAY_5} !important;
    background-color: transparent !important;
    box-sizing: border-box;
    padding: 0 16px !important;
    text-align: left;
    font-family: NunitoSansRegular !important;
    font-size: 18px !important;
    font-weight: 400 !important;
    color: ${COLOR.BLACK_6} !important;
  }
  .content-container > .content > .content-body .number-input {
    flex: 1;
    line-height: 36px;
    min-height: 36px;
    outline: none;
    min-width: 40px;
    max-width: 90px;
  }
  .content-container > .content > .content-body .textarea-field {
    flex: 1;
    line-height: 36px;
    min-height: 36px;
    outline: none;
    min-width: 210px;
    max-width: 560px;
    font-size: 16px;
    letter-spacing: 0;
    padding: 0px 20px;
    margin: 0;
  }
  .content-container > .content  > .content-body .project-name-checkbox > *,
  .content-container > .content > .content-body > * {
    line-height: 36px;
    min-height: 36px;
    outline: none;
  }
  .content-container > .content > .content-body > *:first-child {
    flex: 1 1 100%;
    width: 100%;
    margin: 0;
  }
  .content-container > .content  > .content-body .project-name-checkbox {
    margin: 0 0 0 0;
  }
  .content-container > .content > .content-header .project-name-checkbox {
    margin: 0;
    align-items: center;
  }
  .content-container > .content  > .content-body .text-button {
    font-size: ${FONT_SIZE.TN};
  }
  .content-container > .content > .content-body .text-area {
    height: 144px !important;
    border-radius: 8px !important;
    border: 1px solid ${COLOR.GRAY_5} !important;
    padding: 12px 16px !important;
    width: 100%;
    max-width: 100% !important;
    box-sizing: border-box;
    font-family: NunitoRegular, 'Nunito Sans', sans-serif;
    font-size: 18px;
    line-height: 24px !important;
    color: ${COLOR.BLACK_6};
  }
  .content-container > .content > .content-body .text-area::placeholder {
    font-family: NunitoRegular, 'Nunito Sans', sans-serif;
    font-size: 18px;
    color: ${COLOR.GRAY_27};
  }
  .content-container > .content  > .content-body .date-input-block {
    position: relative;
  }
  .booking-container > .button-container {
    display: flex;
    height: 80px;
    padding: 0 32px;
    margin: 0 0px 0 -32px;
    justify-content: flex-end;
    align-items: center;
    flex-flow: row wrap;
    border-top: 1.5px solid ${COLOR.GRAY_5};
    background-color: #FFFFFF;
    position: sticky;
    bottom: 0;
    z-index: 8;
  }
  .btn-back, .btn-clear, .btn-save, .btn-save-pass, .btn-upload-file{
    min-height: 40px;
    padding: 10px 24px;
    border-radius: 8px;
    font-size: 14px;
    line-height: 20px;
    font-family: NunitoSansMedium, 'Nunito Sans', sans-serif;
    font-weight: 500;
    color: ${COLOR.BLACK_6} !important;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .btn-clear, .btn-upload-file{
    color: ${COLOR.BLACK_1};
  }
  .btn-back {
    background: transparent;
    border: 1px solid ${COLOR.GRAY_5};
  }
  .btn-save, .btn-save-pass{
    cursor: pointer;
    margin-left: 12px;
    border: none;
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .btn-save-pass, .btn-upload-file{
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    cursor: pointer;
  }
  .btn-save, .btn-save-pass, .btn-upload-file{
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT} !important;
  }
  .gold-text {
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .margin-12 {
    margin: 0 12px;
  }
  .margin-8 {
    margin: 0 8px;
  }
  .margin-btm-5 {
    margin-bottom: 5px;
  }
  .column-nowrap {
    flex-flow: column nowrap;
  }
  .flex-horizontal {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-flow: row wrap;
  }
  .change-button {
    cursor: pointer;
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    font-family: NunitoSansRegular;
    border: 0;
    background-color: transparent;
    font-size: ${FONT_SIZE.XXS};
  }
  .repeat-text {
    margin: 0;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
  }
  .flex-vertical {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    flex-flow: column nowrap;
  }
  .flex-checkbox {
   display: flex;
   flex-flow: column nowrap;
   gap: 8px;
   min-width: 210px;
   max-width: 560px;
   width: 100%;
  }
  .flex-link {
   display: flex;
   flex-flow: row wrap;
   margin-top: 12px;
   align-items: center;
   border: 1.5px solid ${COLOR.GRAY_5};
   border-radius: 8px;
   padding: 0 16px;
   min-height: 48px;
  }
  .flex-link img {
    margin-right: 10px;
  }
  .input-link {
   flex: 1;
  }

  input.input-body {
     width: 100% !important;
     line-height: 32px !important;
     min-height: 32px !important;
     border-radius: 4px;
     font-family: 'NunitoSans', sans-serif !important;
     font-size: 18px !important;
     font-weight: 400 !important;
     color: ${COLOR.BLACK_6} !important;
     box-sizing: border-box;
     outline: none;
     border: none;
     background: transparent;
     padding: 0 !important;

     &:disabled {
       cursor: not-allowed;
       color: ${COLOR.GRAY_24} !important;
     }

     &::placeholder,
     &::-webkit-input-placeholder,
     &::-moz-placeholder {
       color: ${COLOR.GRAY_27} !important;
       opacity: 1 !important;
       font-size: 18px !important;
       font-weight: 400 !important;
     }
  }
  .no-margin {
    margin: 0 !important;
  }
  .no-padding {
    padding: 0 !important;
  }
  .stretch {
    justify-content: stretch;
  }
  .text-character {
    color: ${COLOR.GRAY_27};
    font-size: 14px;
    font-family: 'NunitoSansRegular', sans-serif;
    line-height: 1;
    min-height: unset !important;
    text-align: left;
    margin-top: -4px;
  }
  .booking-title {
    font-size: 32px;
    font-weight: 600;
    font-family: "Libre Baskerville", serif;
    color: ${COLOR.BLACK_5};
  }
  .calendar-button {
    border-radius: 4px;
    align-self: center;
    flex: 0;
    padding: 0;
    margin: auto auto auto -1px;
    box-sizing: border-box;
    min-width: 26px;
    min-height: 26px;
    max-width: 26px;
    max-height: 26px;
    cursor: pointer;
  }
  .catering-button {
    height: 28px;
    width: 28px;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
  .catering-button:hover {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
  }
  .catering-button:active {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
  }
  .catering-button:focus {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
  }
  .position-relative {
    position: relative;
  }
  .calendar-button .a {
    fill: none;
  }
  .calendar-button .b {
    stroke: ${COLOR.GRAY_6};
    fill: ${COLOR.GRAY_6};
  }
  .calendar-button:hover .b {
    stroke: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    fill: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .calendar-button:focus,
  .calendar-button:active {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .calendar-button:active .b,
  .calendar-button:focus .b {
    stroke: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    fill: ${COLOR.WHITE};
  }
  .calendar-button.disabled {
    cursor: not-allowed !important;
  }
  .calendar-button.disabled {
    background-color: transparent;
  }
  .calendar-button.disabled .b {
    stroke: ${COLOR.GRAY_6} !important;
    fill: ${COLOR.GRAY_6} !important;
  }

  .div-issue{
    background: ${COLOR.BLACK_1};
    border: 1px solid ${COLOR.GRAY_6};
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left:0;
    opacity: 0.7;
    z-index: ${Z_INDEXS.LV_5};
  }

  .content-issue{
    border-radius: 8px;
    z-index: ${Z_INDEXS.LV_5};
    color: ${COLOR.BLACK_1};
    display: block;
    position: fixed;
    background: #FFF;
    top: calc(50% - 300px);
    height: 560px;
    width: ${660 - padding}px;
    font-size: ${FONT_SIZE.XXS};
    padding: ${padding}px;
    padding-bottom: 26px;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-animation-name: issue; /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
    animation-name: issue;
    animation-duration: 0.5s;
  }

  .box-content{
    height: 410px;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-left: 20px;
    padding-right: 20px
  }

  .header-issue{
    font-size: ${FONT_SIZE.SM};
    font-weight: bold;
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: center;
  }

  .text-issue{
    padding-top: 20px;
    padding-bottom: 6px;
  }

  .field{
    border: 1px solid ${COLOR.GRAY_6};
    padding: 0 16px 0 16px;
    border-radius: 4px;
    background: ${COLOR.GRAY_4};
    font-size: ${FONT_SIZE.TN};
    box-sizing: border-box;
    line-height: 36px;
    min-height: 36px;
    outline: none;
  }

  .upload {
    display: block;
    cursor: pointer;
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${COLOR.BLACK_1};
    padding: 4px !important;
    border-radius:4px;
    line-height: 30px;
    width: 150px;
    padding-left: 0px !important;
    border: none;
    text-align: center;
    font-size: 16px;
  }

  input[type="file"] {
    display: none;
  }

  .text-data3{
    margin-bottom: 10px;
    color: ${COLOR.GRAY_8};
  }

  .text-fail{
    color: ${COLOR.RED_2}
  }

  .box-image{
    width: 616px
  }

  .tabel-image {
    display: table;
  }

  .list-image, .list-image2 {
    margin-top: 5px;
    width: 286px;
    padding: 5px;
    background: ${COLOR.GRAY_1};
    margin-right: 12px;
    float: left;
    border-radius:4px;
  }
  .list-image2 {
    float: right;
  }

  .picture-room {
    cursor: pointer;
    object-fit: cover;
    width: 52px;
    height: 32px;
    border: 3px solid ${COLOR.WHITE};
    vertical-align: middle;
    margin-left: 5px;
    margin-right: 10px;
  }

  .text-image{
    color: ${COLOR.GRAY_3};
    font-size: ${FONT_SIZE.TN};
    margin-bottom: 10px
  }

  .text-fileImage{
    border-bottom: 1px solid ${COLOR.BLACK_1};
  }

  .delete-image {
    cursor: pointer;
    float: right;
    height: 38px;
  }

  .btn-issue{
    margin-top: 28px;
    text-align: center;
  }

  .close-issue, .save-issue{
    float: none;
    width: 182px;
    margin-left: 8px;
    margin-right: 8px;
    color: ${COLOR.BLACK_1};
  }

  .close-issue{
    background: ${COLOR.WHITE};
    color: ${COLOR.BLACK_1};
  }

  .save-issue{
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1}
  }

  .image-count{
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    font-weight: bold;
  }

  .line-height-20{
    line-height: 20px!important;
  }

  .button-icon:hover {
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1}
  }
  .button-icon:active {
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1}
  }
  .button-icon:focus {
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1}
  }
  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes issue {
    0%   {
      padding-left: 0px;
      padding-right: 0px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  /* Standard syntax */
  @keyframes issue {
    0%   {
      padding-left: 0px;
      padding-right: 0px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  .content-container > .content > .content-body .desk-space-field {
    justify-content: flex-start;
    gap: 4px;
    font-family: NunitoSansRegular;
    font-size: 18px;
    line-height: 22px;
    color: ${COLOR.BLACK_6};
    text-align: left;
    cursor: pointer;

    &:disabled {
      background-color: ${NATIVE_BASE_COLORS.TEXT[100]} !important;
      color: ${COLOR.GRAY_27};
      cursor: not-allowed;

      .desk-space-arrow {
        display: none;
      }
    }
  }

  .desk-space-value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.placeholder {
      color: ${COLOR.GRAY_27};
    }
  }

  .desk-space-checkin {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    mask: url(${IMG['ic_require-checkin.svg']}) center / contain no-repeat;
    -webkit-mask: url(${IMG['ic_require-checkin.svg']}) center / contain no-repeat;
  }

  .desk-space-arrow {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    margin-left: auto;
  }
`

export default Style

